import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import { VuetifyOptions } from '@zucommunications/gsk-docshare-web-design-system'

Vue.use(Vuetify)

export default new Vuetify(VuetifyOptions)
